import { fetchTagSuccess } from './fetch-tag';
import { fetchTagsSuccess } from './fetch-tags';
export const tagsReducer = (state = [], { type, payload } = {}) => {
    switch (type) {
        case fetchTagSuccess.type:
            return [...state, payload];
        case fetchTagsSuccess.type:
            return payload;
        default:
            return state;
    }
};
export default tagsReducer;
//# sourceMappingURL=tags-reducer.js.map